<div class="btn-group">
  <button type="button" mat-raised-button color="accent" (click)="openCreateDialog()">{{'SHARED.Button.Create' | translate }}</button>
</div>
<div class="enquiries-list">
  <mvms-list-enquiries></mvms-list-enquiries>
</div>

